export default (ms) => new Promise(res => setTimeout(res, ms));


// WEBPACK FOOTER //
// ./src/utilities/sleep.js